import { t } from "i18next";
import React, { Fragment } from "react";
import { Col, Container, Row } from "react-bootstrap";

const FrontPageCMS = () => {
    return (
        <Fragment>
            <Container fluid="lg" id="addEditPass">
                <Row>
                    <Col xs={12} className="px-4 my-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">
                            {t(`frontPage.title`)} - {t("settings.settings")}
                        </h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <p className="h5 my-3">{t("inProgress")}</p>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default FrontPageCMS;
